import PageBrand from '@components/common/PageBrand'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import qs from 'qs'
import Alert, { AlertInput, handleAlert } from '../components/common/Alert'
import { sha256 } from 'js-sha256'
import { err, wait } from '../utils/functions'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { resetPassword } from '../api/user'
import TextField from '@mui/material/TextField'
import Container from '@mui/material/Container'
import { GlassCard, GlassOutlineButton } from '@components/common/Glass'
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded'

export default function ResetPassword(): JSX.Element {
  const history = useHistory()

  const { uuid: uuidParam, code: codeParam } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  }) as { [k: string]: string }

  const [alert, setAlert] = useState<AlertInput>({ open: false })

  const [password, setPassword] = useState<string>()
  const [checkPassword, setCheckPassword] = useState<string>()

  const handleReturn = () => {
    history.push('/login')
  }

  useEffect(() => {
    if (!codeParam) {
      history.push('/forgotPassword')
    }
  }, [codeParam, history])

  const handleSendResetLink = async () => {
    if (!uuidParam || !codeParam || !password || !checkPassword) return

    const [hashPass, hashCheckPass] = await Promise.all([sha256(password), sha256(checkPassword)])

    resetPassword(uuidParam, codeParam, hashPass, hashCheckPass)
      .then(async (res) => {
        handleAlert(setAlert, res, 'Password reset! Redirecting to login')

        if (res.success) {
          await wait(2000)
          history.push('/login')
        }
      })
      .catch((e) => {
        err(e)
      })
  }

  return (
    <Container maxWidth="sm" sx={{ py: 3, pb: 5 }}>
      <PageBrand />
      <GlassCard sx={{ p: { xs: 2.5, sm: 4 }, mt: 3, textAlign: 'left' }}>
        <GlassOutlineButton
          aria-label="Back to login"
          onClick={handleReturn}
          sx={{ minWidth: 40, p: 1, mb: 2 }}
        >
          <ArrowBackIosNewRoundedIcon fontSize="small" />
        </GlassOutlineButton>
        <form
          onSubmit={async (e) => {
            e.preventDefault()
            await handleSendResetLink()
          }}
        >
          <Typography variant="h4" component="h1">
            A fresh start
          </Typography>
          <Typography color="text.secondary" mt={1} mb={3}>
            Set a new password for your RankTrivia account.
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="New password"
                type="password"
                fullWidth
                required
                value={password || ''}
                autoComplete="new-password"
                name="password"
                onChange={(e) => setPassword(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Confirm new password"
                type="password"
                fullWidth
                required
                value={checkPassword || ''}
                autoComplete="new-password"
                name="password-confirm"
                onChange={(e) => setCheckPassword(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" fullWidth type="submit">
                Reset password
              </Button>
            </Grid>
          </Grid>
        </form>
      </GlassCard>
      <Alert alert={alert} onClose={() => setAlert({ ...alert, open: false })} />
    </Container>
  )
}
